module.exports = __webpack_public_path__ + "img/bg.e3fdbc1d.webp";